import { TextInput } from "@mantine/core";
import classes from "./smaui-textinput.module.css";

export const SmaUiTextInput = (props) => {
    return (
        <TextInput
            {...props}
            variant="unstyled"
            classNames={classes}
        />                                                                                                              
    )
}